import { useInfiniteQuery } from "@tanstack/react-query";
import { getLessonUnits } from "@/services/lessonsService";
import { filterParams } from "@/utils/filterParams";
import { VISIBILITY } from "@/types";

const LIMIT = 15;

export const useLessonList = (s?: string) => {
  const queryKey = ["lesson-list", s];

  const query = useInfiniteQuery({
    queryKey: queryKey,
    queryFn: ({ pageParam = 1 }) =>
      getLessonUnits(
        filterParams({
          page: pageParam,
          isPagination: 1,
          limit: LIMIT,
          orderBy: "id",
          order: "DESC",
          status: VISIBILITY.public,
          s: s,
        })
      ),
    getNextPageParam: (lastPage: any) => {
      return lastPage.pagination?.hasNextPage
        ? lastPage.pagination.page + 1
        : undefined;
    },
    initialPageParam: 1,
  });

  return { ...query };
};
